import React from "react";

const Program = () => {
  return (
    <div>
   
 
 <div className="parent-chart process-bg container ptb20">
        <div className="hiretrainlevel lev-one top-level">
          <div className="text-center" align="center">
            <div className="hiretrainheading section-title text-center position-relative pb-3 mb-5 mx-auto">
              <h2>Our Program</h2>
              <div className="HandT_para">
                <p>
                  In PabJob's students are trained through the Train and Hire
                  model of learning for job-readiness and are eventually
                  on-boarded to leading IT Company's. The 90 days intensive
                  program develops the key skills that are required by
                  top-ranked tech companies, covering major skilling problems,
                  collaborative projects, code challenges, and interview
                  clinics. Thereby, candidates jumpstart their careers in top
                  Company's through the Train and Hire Program.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="flow-chart">
          <div className="hiretrainlevel lev-two last-lev">
            <div className="pre-loader">
              <div className="">
                <div className="hiretrainposition">
                  <img
                    src="images/Icon - 01.png"
                    // id="animated-example"
                    className="animated1 bounce"
                    alt="data engineer job openings"
                  />
                  <br />
                  <a href="#eligibilitytab">
                    <strong className="hiretraineligibilty"> Hiring</strong>
                  </a>
                  <br />
                  Hiring as per Company's specifications
                </div>
                <div className="hiretrainposition">
                  <img
                    src="images/Icon - 02.png"
                    // id="animated-example"
                    className="animated2 bounce2"
                    alt="azure-data-engineer-openings"
                  />
                  <br />
                  <a href="#flowchart">
                    <strong className="hiretrainevalution">Eiligiblity Critiea</strong>
                  </a>
                  <br />
                  Eiligiblity Critiea of Aptitude, Cognitive Skills, Coding
                  Aptitude, and Verbal Reasoning
                </div>
                <div className="hiretrainposition">
                  <img
                    src="images/Icon - 03.png"
                    // id="animated-example"
                    className="animated3 bounce"
                    alt="aws data engineering training"
                  />
                  <br />
                  <a href="#flowchart">
                    <strong className="hiretraintraining">
                      Clearing Initial Assementg
                    </strong>
                  </a>
                  <br />
                  Zero Cost Technical Skill training
                </div>
                <div className="hiretrainposition">
                  <img
                    src="images/Icon - 04.png"
                    // id="animated-example"
                    className="animated4 bounce2"
                    alt="azure data engineer jobs"
                  />
                  <br />
                  <br />
                  <div className="fourth_img">
                  <a href="#flowchart">
                    <strong className="hiretraininterview">
                      {" "}
                      40-50 days engaged learning program{" "}
                    </strong>
                  </a>
                  <br />
                  Continuous Assessments by the Company
                  </div>
                </div>
                <div className="hiretrainposition">
                <img
                    src="images/Icon - 05.png"
                    // id="animated-example"
                    className="animated5 bounce"
                    alt="azure data engineer jobs"
                  />
                  <br />
                  <a href="#flowchart">
                    <strong className="hiretrainonboarding">
                      Certified subject experts
                    </strong>
                  </a>
                  <br />
                  Offer letter and Onboarding
                </div>
                <div className="hiretrainposition">
                  <img
                    src="images/Icon - 06.png"
                    // id="animated-example"
                    className="animated6 bounce2"
                    alt="data engineer job openings"
                  />
                  <br />
                  <a href="#eligibilitytab">
                    <strong className="hiretraineligibilty">
                      {" "}
                      Continous assesment travel to track learning process
                    </strong>
                  </a>
                  <br />
                  Eligibility as per Company's specifications
                </div>
                <div className="hiretrainposition">
                  <img
                    src="images/Icon - 07.png"
                    // id="animated-example"
                    className="animated7 bounce"
                    alt="azure-data-engineer-openings"
                  />
                  <br />
                  <a href="#flowchart">
                    <strong className="hiretrainevalution">
                      Mock Hr and Technical Interview
                    </strong>
                  </a>
                  <br />
                  Evaluation of Aptitude, Cognitive Skills, Coding Aptitude, and
                  Verbal Reasoning
                </div>
                <div className="hiretrainposition">
                  <img
                    src="images/Icon - 08.png"
                    // id="animated-example"
                    className="animated8 bounce2"
                    alt="aws data engineering training"
                  />
                  <br />
                  <a href="#flowchart">
                    <strong className="hiretraintraining">Final assesment</strong>
                  </a>
                  <br />
                  Zero Cost Technical Skill training
                </div>
                <div className="hiretrainposition">
                  <img
                    src="images/Icon - 09.png"
                    // id="animated-example"
                    className="animated9 bounce"
                    alt="azure data engineer jobs"
                  />
                  <br />
                  <br />
                  <div className="fourth_img">
                  <a href="#flowchart">
                    <strong className="hiretraininterview">
                      Training Face to Face Interview{" "}
                    </strong>
                  </a>
                  <br />
                  Continuous Assessments by the Company
                  </div>
                </div>
                <div className="hiretrainposition">
                  <img
                    // id="animated-example"
                    className="animated10 bounce2"
                    src="images/Icon - 10.png"
                    alt="become a big data engineer"
                  />
                  <br />
                  <a href="#flowchart">
                    <strong className="hiretrainonboarding">On Boarding</strong>
                  </a>
                  <br />
                  Offer letter and Onboarding
                </div>
              </div>
            </div>

            {/* <div className="position">
<img src="images/Icon - 06-01 (1).png"  id="animated-example" className="animated2 bounce" alt="azure data engineer jobs" /><br  /><br />
<a href="#flowchart"><strong className="interview">Periodical Assessments </strong></a><br />
Continuous Assessments by the Company

</div> *
          </div>
        </div> */}
        <div className="ml-auto">
                  <img src="images/Infinity.gif" className="img-fluid" style={{marginTop:"150px"}}/>
                  </div>

      </div>
    </div>
  );
};

export default Program;
